import { Component, OnInit } from '@angular/core';
import { SitePagesService } from '../../../data-services/site-pages.service';
import { FAQ } from '../../../data-services/models/faq.model';

@Component({
  selector: 'app-faq',
  imports: [],
  templateUrl: '../ui/faq.component.html'
})
export class FaqComponent implements OnInit{
  faqList?: FAQ[];
  constructor(protected sitePages:SitePagesService){

  }

  ngOnInit(): void {
    //this.sitePages.getFaq().then(result => this.faqList = result);
  }
}
